<template>
  <div v-if="shop">
    <notifications group="b2b" />
    <vue-headful
      :title="findShopSettingValue('B2B_SEO_TITLE')"
      :description="findShopSettingValue('B2B_SEO_DESCRIPTION')"
      :keywords="findShopSettingValue('B2B_SEO_KEYWORDS')"
    />
    <Header />
    <MenuLeft />
    <Content>
      <router-view />
    </Content>
    <RightWindow />
    <BottomMobilePanel />
  </div>

  <div v-else="!shop">Loading...</div>
</template>

<script>
import { mapState } from "vuex";
import Header from "./components/template/Header.vue";
import MenuLeft from "./components/template/MenuLeft.vue";
import Content from "./components/template/Content.vue";
import RightWindow from "./components/template/RightWindow.vue";
import BottomMobilePanel from "./components/template/BottomMobilePanel.vue";
import vueHeadful from "vue-headful";
import notifications from "vue-notification";

export default {
  name: "app",
  components: {
    Header,
    MenuLeft,
    Content,
    RightWindow,
    BottomMobilePanel,
    vueHeadful
  },
  computed: {
    ...mapState({
      shop: state => state.shop
    })
  },
  methods: {
    findShopSettingValue(type) {
      let setting = this.shop.settings.find(s => s.name == type);
      return setting ? setting.value : "";
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/App.vue